import {UseFormReturn} from "react-hook-form";
import {useTranslation} from "react-i18next";
import {Grid} from "@mui/material";
import {LabeledInput} from "../base/LabeledInput";
import {COUNTRY_OPTIONS} from "../../utils/countriesUtils";
import {CheckboxInput} from "../base/CheckboxInput";
import {TextInput} from "../base/TextInput";
import {AutocompleteInput} from "../base/AutocompleteInput";

export interface UserRegistrationFormInputs {
    firstName: string;
    lastName: string;
    email: string;
    company: string;
    country: string | null;
    phone: string;
    password: string;
    repeatPassword: string;
    enabledMarketingEmails: boolean;
}

export interface Props {
    initFormValues: UserRegistrationFormInputs;
    form: UseFormReturn<UserRegistrationFormInputs>;
}

export const UserRegistrationForm: React.FC<Props> = ({
    initFormValues,
    form: {
        register,
        control,
        formState: {errors},
    },
}) => {
    const {t} = useTranslation();
    return (
        <Grid container spacing={2}>
            <Grid item xs={12}>
                <LabeledInput label={t("users.registration_form.email")}>
                    <TextInput
                        name="email"
                        type="text"
                        register={register}
                        errors={errors}
                        inputProps={{autoFocus: true, autoComplete: "email"}}
                    />
                </LabeledInput>
            </Grid>
            <Grid item xs={12} sm={6}>
                <LabeledInput label={t("users.registration_form.firstname")}>
                    <TextInput
                        name="firstName"
                        type="text"
                        register={register}
                        errors={errors}
                        inputProps={{autoComplete: "given-name"}}
                    />
                </LabeledInput>
            </Grid>
            <Grid item xs={12} sm={6}>
                <LabeledInput label={t("users.registration_form.lastname")}>
                    <TextInput
                        name="lastName"
                        type="text"
                        register={register}
                        errors={errors}
                        inputProps={{autoComplete: "family-name"}}
                    />
                </LabeledInput>
            </Grid>
            <Grid item xs={12} sm={6}>
                <LabeledInput label={t("users.registration_form.country")}>
                    <AutocompleteInput
                        name="country"
                        control={control}
                        options={COUNTRY_OPTIONS}
                        disableClear
                        initialValue={initFormValues.country}
                        getOptionLabel={(option) => option.label}
                    />
                </LabeledInput>
            </Grid>
            <Grid item xs={12} sm={6}>
                <LabeledInput label={t("users.registration_form.phone")}>
                    <TextInput
                        name="phone"
                        type="text"
                        register={register}
                        errors={errors}
                        inputProps={{autoComplete: "tel"}}
                    />
                </LabeledInput>
            </Grid>
            <Grid item xs={12}>
                <LabeledInput label={t("users.registration_form.password")}>
                    <TextInput
                        name="password"
                        type="password"
                        register={register}
                        errors={errors}
                        inputProps={{autoComplete: "new-password"}}
                    />
                </LabeledInput>
            </Grid>
            <Grid item xs={12}>
                <LabeledInput label={t("users.registration_form.repeat_password")}>
                    <TextInput name="repeatPassword" type="password" register={register} errors={errors} />
                </LabeledInput>
            </Grid>
            <Grid item xs={12}>
                <CheckboxInput
                    name="enabledMarketingEmails"
                    control={control}
                    initialValue={initFormValues.enabledMarketingEmails}
                    label={t("users.registration_form.marketing")}
                />
            </Grid>
        </Grid>
    );
};
